/**
 * @file index.tsx
 *
 * @fileoverview Renders the layout for the user register.
 */
import React from 'react';
import { FormWithImage } from '~/vcl/organisms/01-form/02-withImage';
import { useIntl } from 'react-intl';
import { Main } from '~/vcl/atoms/06-layout/09-main';

interface UserRegisterLayoutProps {
  /**
   * The children to render inside the layout.
   */
  children: React.ReactNode;
  /**
   * The image to display on the layout, in case of a form with image layout.
   */
  registerImage?: string;
}
export default function UserRegisterLayout({
  children,
  registerImage,
}: UserRegisterLayoutProps) {
  const intl = useIntl();
  return registerImage ? (
    <main>
      <FormWithImage
        image={registerImage}
        title={intl.formatMessage({
          id: 'register_image_title',
          defaultMessage: 'Register',
        })}
        alt={intl.formatMessage({
          id: 'register_image_alt',
          defaultMessage: 'Register banner',
        })}
      >
        {children}
      </FormWithImage>
    </main>
  ) : (
    <Main>
      <main>{children}</main>
    </Main>
  );
}
